import { Injectable } from '@angular/core';
import { SessionService } from './session.service';
import { ConfigService } from './config.service';

@Injectable()
export class Guard {
    private permissions: any = {};
    private env: string;
    private buyerPermissions: any;
    private buyerAdminPermissions: any;
    private trainingManagerPermissions: any;
    private sellerPermissions: any;
    private itpxFinancePermissions: any;
    private itpxPermissions: any;
    private applicationManagerPermissions: any;
    private adminPermissions: any;
    private devPermissions: any;
    private buyerAndSellerPermissions: any;

    constructor(private sessionService: SessionService, private configService: ConfigService) {
        this.env = configService.get('envName');
        this.refreshPermissions();
    }

    refreshPermissions() {
        let user = this.sessionService.getUserDetails();
        this.permissions = {};

        this.buyerAdminPermissions = {
            'lxp-configuration': true,
            buyerApproval: true,
            buyerAdminApproval: true,
            buyerGeneralApproval: true
        };

        this.trainingManagerPermissions = {
            'lxp-configuration': true
        };

        this.buyerPermissions = {
            generalSeparator: true,
            solar: true,
            classes: true,
            organization: true,
            om: true,
            support: true,
            legal: true,
            cm: true,
            um: true,
            invoices: true,
            purchase: true,
            buyerContracts: true,
            report: true,
            transactionsBuyer: true,
            buyerInstructorBooking: true,
            'organization.credit-application': true,
            buyerApproval: true,
            buyerGeneralApproval: true
        };

        this.sellerPermissions = {
            sellerInstructorBooking: true,
            sellerProducts: true,
            sellerMarketplace: true,
            sellerPricing: true,
            sellerInvitations: true,
            sellerContracts: true,
            sellerContractTemplates: true,
            sellerContractsSegments: true,
            'sellerProducts.shipping-data': true,
            'sellerProducts.product-data': true,
            'sellerProducts.product-restrictions': true,
            'sellerProducts.sub-categories': true,
            'library-seller': true,
            'solar.exams.seller-exam-fulfillment': true,
            promotions: true,
            generalSeparator: true,
            organization: true,
            support: true,
            legal: true,
            broadcastSeller: true,
            'courses-seller': true
        };

        this.buyerAndSellerPermissions = {
            sellerSeparator: true,
            buyerSeparator: true
        };

        this.itpxFinancePermissions = {
            generalSeparator: true,
            transactions: true,
            legal: true
        };

        this.itpxPermissions = {
            generalSeparator: true,
            buyerSeparator: true,
            leapestSeparator: true,
            'library-platform': true,
            delivery: true,
            dm: true,
            voucher: true,
            sm: true,
            agora: true,
            contract: true,
            tm: true,
            report: true,
            transactions: true,
            legal: true,
            sellerInstructorBooking: true,
            sellerProducts: true,
            sellerPricing: true,
            'sellerProducts.shipping-data': true,
            'sellerProducts.product-data': true,
            'sellerProducts.bulk-uploads': true,
            'sellerProducts.product-restrictions': true,
            'sellerProducts.sub-categories': true,
            sellerInvitations: true,
            sellerContracts: true,
            sellerContractTemplates: true,
            sellerContractsSegments: true,
            platformContractTemplates: true,
            platformContracts: true,
            notificationManagement: true,
            promotions: true,
            'agora.account-data': true,
            'agora.account-data.accounts': true,
            'agora.account-data.employees': true,
            'agora.account-data.addresses': true,
            'agora.configurations': true,
            'agora.account-data.bank-data': true,
            'agora.account-data.tax-data': true,
            'agora.account-data.credit': true,

            'agora.product-data': true,
            'agora.pricing-data': true,
            'agora.product-data.catalogs': true,
            'agora.product-data.categories': true,
            'agora.product-data.products': true,
            'agora.product-data.product-variants': true,
            'solar.exams.seller-exam-fulfillment': true,

            registrations: true,
            platformSellerProducts: true,
            promotionsPlatform: true,
            broadcastSeller: true,
            marketingPlatform: true,
            buyerApproval: true,
            buyerAdminApproval: true,
            buyerGeneralApproval: true,

            'courses-seller': true,
            'courses-platform': true,
            platformSupplierManagement: true,
            approvalPlatform: true,
            sellerMarketplace: true,

            'vms-enabled': true
        };

        this.applicationManagerPermissions = {
            generalSeparator: true,
            leapestSeparator: true,
            buyerSeparator: true,
            sellerSeparator: true,
            platformSeparator: true,
            'library-platform': true,
            delivery: true,
            eden: true,
            dm: true,
            solar: true,
            classes: true,
            voucher: true,
            organization: true,
            'organization.credit-application': true,
            tm: true,
            sm: true,
            om: true,
            support: true,
            legal: true,
            agora: true,
            buyerContracts: true,
            lunar: true,
            transactions: true,
            transactionsBuyer: true,
            sellerInstructorBooking: true,
            sellerInvitations: true,
            sellerContracts: true,
            sellerContractTemplates: true,
            sellerContractsSegments: true,
            buyerInstructorBooking: true,
            sellerProducts: true,
            sellerPricing: true,
            'sellerProducts.shipping-data': true,
            'sellerProducts.product-data': true,
            'sellerProducts.bulk-uploads': true,
            'sellerProducts.bulk-uploads.configurations': true,
            'sellerProducts.product-restrictions': true,
            'sellerProducts.sub-categories': true,
            report: true,
            notificationManagement: true,
            promotions: true,
            'agora.account-data': true,
            'agora.account-data.accounts': true,
            'agora.account-data.employees': true,
            'agora.account-data.addresses': true,
            'agora.configurations': true,
            'agora.account-data.bank-data': true,
            'agora.account-data.tax-data': true,
            'agora.account-data.credit': true,
            'support.knowledge-base': true,
            platformContractTemplates: true,
            platformContracts: true,
            broadcastSeller: true,
            marketingPlatform: true,
            buyerApproval: true,
            buyerAdminApproval: true,
            buyerGeneralApproval: true,
            'courses-seller': true,
            'courses-platform': true,
            platformSupplierManagement: true,
            approvalPlatform:true,
            sellerMarketplace:true,
            'vms-enabled': true
        };

        this.adminPermissions = {
            generalSeparator: true,
            leapestSeparator: true,
            buyerSeparator: true,
            sellerSeparator: true,
            platformSeparator: true,
            amber: true,
            marketingPlatform: true,
            'library-platform': true,
            'library-seller': true,
            delivery: true,
            eden: true,
            dm: true,
            solar: true,
            classes: true,
            courses: true,
            voucher: true,
            organization: true,
            'organization.credit-application': true,
            contract: true,
            tm: true,
            sm: true,
            om: true,
            support: true,
            legal: true,
            cm: true,
            um: true,
            transactions: true,
            transactionsBuyer: true,
            purchase: true,
            agora: true,
            buyerContracts: true,
            report: true,
            lunar: true,
            sellerInstructorBooking: true,
            buyerInstructorBooking: true,
            sellerProducts: true,
            sellerPricing: true,
            'sellerProducts.shipping-data': true,
            'sellerProducts.product-data': true,
            'sellerProducts.product-restrictions': true,
            'sellerProducts.sub-categories': true,
            'sellerProducts.bulk-uploads': true,
            'sellerProducts.bulk-uploads.configurations': true,
            sellerInvitations: true,
            sellerContracts: true,
            sellerContractTemplates: true,
            sellerContractsSegments: true,
            notificationManagement: true,
            promotions: true,
            'agora.account-data': true,
            'agora.account-data.accounts': true,
            'agora.account-data.employees': true,
            'agora.account-data.addresses': true,
            'agora.configurations': true,
            'agora.product-data': true,
            'agora.pricing-data': true,
            'agora.product-data.catalogs': true,
            'agora.product-data.categories': true,
            'agora.product-data.products': true,
            'agora.product-data.product-variants': true,
            'agora.account-data.bank-data': true,
            'agora.account-data.tax-data': true,
            'agora.account-data.credit': true,
            'support.knowledge-base': true,
            'solar.exams.seller-exam-fulfillment': true,
            registrations: true,

            platformContractTemplates: true,
            platformContracts: true,
            platformSellerProducts: true,
            promotionsPlatform: true,
            broadcastSeller: true,
            'lxp-configuration': true,
            buyerApproval: true,
            buyerAdminApproval: true,
            buyerGeneralApproval: true,
            'courses-seller': true,
            'courses-platform': true,
            platformSupplierManagement: true,
            approvalPlatform:true,
            sellerMarketplace:true,
            'vms-enabled': true,
            webcamAssessments:true
        };

        this.devPermissions = {
            generalSeparator: true,
            leapestSeparator: true,
            buyerSeparator: true,
            sellerSeparator: true,
            platformSeparator: true,
            amber: true,
            'library-platform': true,
            delivery: true,
            eden: true,
            dm: true,
            solar: true,
            classes: true,
            voucher: true,
            organization: true,
            'organization.credit-application': true,
            contract: true,
            tm: true,
            sm: true,
            om: true,
            support: true,
            legal: true,
            cm: true,
            um: true,
            invoices: true,
            purchase: true,
            agora: true,
            buyerContracts: true,
            lunar: true,
            report: true,
            transactions: true,
            transactionsBuyer: true,
            sellerInstructorBooking: true,
            buyerInstructorBooking: true,
            sellerProducts: true,
            sellerMarketplace: true,
            sellerPricing: true,
            'sellerProducts.shipping-data': true,
            'sellerProducts.product-data': true,
            'sellerProducts.product-restrictions': true,
            'sellerProducts.sub-categories': true,
            'sellerProducts.bulk-uploads': true,
            'sellerProducts.bulk-uploads.configurations': true,
            sellerInvitations: true,
            sellerContractsSegments: true,
            notificationManagement: true,
            promotions: true,
            'agora.product-data': true,
            'agora.product-data.catalogs': true,
            'agora.product-data.categories': true,
            'agora.product-data.products': true,
            'agora.product-data.product-variants': true,
            'agora.account-data': true,
            'agora.account-data.accounts': true,
            'agora.account-data.bank-data': true,
            'agora.account-data.tax-data': true,
            'agora.account-data.employees': true,
            'agora.account-data.addresses': true,
            'agora.pricing-data': true,
            'agora.configurations': true,
            'agora.account-data.credit': true,
            'support.knowledge-base': true,
            'solar.exams.seller-exam-fulfillment': true,
            registrations: true,
            platformSellerProducts: true,
            promotionsPlatform: true,
            broadcastSeller: true,
            marketingPlatform: true,
            buyerApproval: true,
            buyerAdminApproval: true,
            buyerGeneralApproval: true,
            'courses-seller': true,
            'courses-platform': true,
            platformSupplierManagement: true,
            approvalPlatform: true,
            'vms-enabled': true
        };

        this.buildPermissions(user);
    }

    buildPermissions(user: any) {
        if (user && user['groups'] && user['groups'].length) {
            if (user['groups'].indexOf('developer') > -1)
                this.permissions = Object.assign(this.permissions, this.devPermissions);
            if (user['groups'].indexOf('administrator') > -1 || user['groups'].indexOf('view-administrator') > -1)
                this.permissions = Object.assign(this.permissions, this.adminPermissions);
            if (user['groups'].indexOf('application-manager') > -1)
                this.permissions = Object.assign(this.permissions, this.applicationManagerPermissions);
            if (user['groups'].indexOf('itpx-finance') > -1)
                this.permissions = Object.assign(this.permissions, this.itpxFinancePermissions);
            if (user['groups'].indexOf('itpx') > -1)
                this.permissions = Object.assign(this.permissions, this.itpxPermissions);
            if (user['groups'].indexOf('buyer') > -1)
                this.permissions = Object.assign(this.permissions, this.buyerPermissions);
            if (user['groups'].indexOf('seller') > -1)
                this.permissions = Object.assign(this.permissions, this.sellerPermissions);
            if (user['groups'].indexOf('buyer') > -1 && user['groups'].indexOf('seller') > -1)
                this.permissions = Object.assign(this.permissions, this.buyerAndSellerPermissions);
            if (user['groups'].indexOf('buyer-admin') > -1)
                this.permissions = Object.assign(this.permissions, this.buyerAdminPermissions);
            if (user['groups'].indexOf('training-manager') > -1)
                this.permissions = Object.assign(this.permissions, this.trainingManagerPermissions);
            if (user['groups'].indexOf('vms-enabled') > -1)
                this.permissions['vms-enabled'] = true;
            if (this.env.toLowerCase() === 'preview' && (user['groups'].indexOf('buyer-admin') > -1 || user['groups'].indexOf('buyer') > -1)) {
                this.permissions.classes = false;
                this.permissions.courses = true;
            } else {
                if (user['groups'].indexOf('buyer-admin') > -1 && user['domain'] === 'sparksquared') {
                    this.permissions.courses = true;
                }
            }

            if (user['groups'].indexOf('administrator') < 0 && (user['domain'] === 'wns')) {
                this.permissions.buyerAdminApproval = false;
                this.permissions.buyerApproval = false;
                this.permissions.buyerContracts = false;
                this.permissions.buyerGeneralApproval = false;
                this.permissions.buyerInstructorBooking = false;
                this.permissions.solar = false;
                this.permissions.purchase = false;
                this.permissions.transactionsBuyer = false;
            }

            if (user['groups'].indexOf('administrator') < 0 && (user['domain'] === 'diageo' ||
                user['domain'] === 'diageouat' || user['domain'] === 'spark') || user['domain'] === 'spotify') {
                this.permissions = {
                    support: true,
                    buyerSeparator: true,
                    generalSeparator: true,
                    legal: true,
                    organization: true,
                    courses: true
                }
            }
        }
        this.checkAgoraConfigurations(user);
    }

    checkAgoraConfigurations(user: any) {
        let agoraPermissions = user ? user['viewPermissions'] : null;
        if (agoraPermissions) {
            let isAdmin = user['groups'].indexOf('administrator') > -1 || user['groups'].indexOf('view-administrator') > -1 || user['groups'].indexOf('itpx') > -1
                || user['groups'].indexOf('application-manager') > -1 || user['groups'].indexOf('itpx-finance') > -1;
            if (isAdmin)
                return null;
            let lmsLightEnabled = agoraPermissions['lmsEnabled'] && agoraPermissions['lmsEnabled']['enabled'];
            
            if (user['groups'].indexOf('buyer') > -1) {
                this.permissions['purchase'] = agoraPermissions['marketplace'];
                this.permissions['solar'] = agoraPermissions['voucherManagement'];
                this.permissions['classes'] = agoraPermissions['classes'];
                this.permissions['transactionsBuyer'] = agoraPermissions['ordersAndInvoices'];
                this.permissions['buyerContracts'] = agoraPermissions['contracts'];
                this.permissions['courses'] = lmsLightEnabled;
                this.permissions['vms-enabled'] = agoraPermissions['vmsEnabled'];
            }

            if (user['groups'].indexOf('buyer-admin') > -1) {
                // LMS Light = FALSE then: a Course Event tile is displayed in the root of the Buyer Admin panel
                this.permissions['lms-light-buyer'] = !lmsLightEnabled;
            }
            if (user['groups'].indexOf('seller') > -1) {
                this.permissions['sellerContracts'] = agoraPermissions['contracts'];
                this.permissions['sellerContractsSegments'] = agoraPermissions['contracts'];
                this.permissions['solar.exams.seller-exam-fulfillment'] = agoraPermissions['ordersAndInvoices'];
                this.permissions['sellerMarketplace'] = agoraPermissions['marketplace'];
            }
            
            if (user['groups'].indexOf('seller-admin') > -1) {
                this.permissions['customAttributes'] = agoraPermissions['customAttributes'];
                this.permissions['webcamAssessments'] = agoraPermissions['webcamAssessments'];
            }
        }
    }

    isAuthorized(permission: string, hideInProd?: boolean, hideInPreview?: boolean, hideInStage?: boolean) {
        if (hideInProd && this.env.toLowerCase() === 'prod') {
            return false;
        }
        if (hideInPreview && this.env.toLowerCase() === 'preview'){
            return false;
        }
        if (hideInStage && this.env.toLowerCase() === 'stage'){
            return false;
        }

        return this.permissions[permission];
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/guard.service.ts